// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"454":"0cebc665","904":"c8abb59b"}[chunkId] + ".chunk.js";
};